import { Result, Spin } from "antd";
import { StoreContext, PlatformFastContextProvider } from "contexts";
import { ordersHooks } from "hooks";
import { IPlatform } from "models";
import React, { useContext } from "react";
import { Trans } from "react-i18next";
import { iframeUtils } from "utils";

const { getDataFromIframe } = iframeUtils;

export interface WithPlatformPermissionNewProps {
  platform: IPlatform;
  isFetchingPlatform: boolean;
}

export const withPlatformPermission_New = <P extends {}>(
  Component: React.FC<P>,
  targetTitle: string
): React.FC<P & WithPlatformPermissionNewProps> => {
  return (props) => {
    const { currentUser } = useContext(StoreContext);
    const userIdentity = currentUser.email || currentUser.phone_number || currentUser.name;
    const userAssignedPlatformId = currentUser?.meta_data?.platformId;

    const { currentPlatform: framePlatformId } = getDataFromIframe();
    const { isFetching, platform } = ordersHooks.useAuthorizedPlatform(framePlatformId, userAssignedPlatformId);

    if (isFetching) return <Spin spinning={isFetching} />;

    // If the user's platform permissions is not set
    if (!platform || !platform.id) {
      return (
        <Result
          status="403"
          subTitle={
            <Trans i18nKey="InvalidUserPlatformMsg">
              Tài khoản <span className="text-primary text-medium"> {{ userIdentity }} </span> chưa được gán Platform
              hợp lệ để xem {{ targetTitle: targetTitle.toLowerCase() }}.
              <br /> Vui lòng liên hệ Admin <a href="mailto:support@teko.vn">support@teko.vn</a>
              để được hỗ trợ.
            </Trans>
          }
        />
      );
    }

    return (
      <PlatformFastContextProvider storeValue={{ platform }}>
        <Component {...props} platform={platform} isFetchingPlatform={isFetching} />;
      </PlatformFastContextProvider>
    );
  };
};
